import { esgReportListStore } from "../stores/esg-report-list.store";

export const useESGReportListStore = () => esgReportListStore;
